<template>
  <SalesDashboardCard title="Earnings" class-card="col-md-4" @set-filter="setFilter" :selected-filter="selectedFilter" :filters="filters">
    <div slot="icon">
      <span class="dashboard-card-icon dashboard-card-icon-earnings" />
    </div>
    <div class="d-flex justify-content-between" slot="body">
      <Loader v-if="loading" />
      <template v-else>
        <div class="d-flex flex-column">
          <span class="total-title">Cluster earned</span>
          <span class="total-value d-flex align-items-center flex-wrap">
            <span>$ {{ total_earned }}</span>
            <span v-if="compared_earned < 0 || compared_earned > 0" class="compared-value" :class="{'compared-value-positive': parseInt(compared_earned) > 0, 'compared-value-negative': parseInt(compared_earned) < 0}">{{ compared_earned }}%</span>
          </span>
        </div>
        <div class="d-flex flex-column">
          <span class="total-title">Carriers payout</span>
          <span class="total-value d-flex align-items-center flex-wrap">
            <span>$ {{ total_payout }}</span>
            <span v-if="compared_payout < 0 || compared_payout > 0" class="compared-value" :class="{'compared-value-positive': parseInt(compared_payout) > 0, 'compared-value-negative': parseInt(compared_payout) < 0}">{{ compared_payout }}%</span>
          </span>
        </div>
      </template>
    </div>
  </SalesDashboardCard>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import SalesDashboardCard from '../SalesDashboardCard';
import Loader from './Loader';

const filters = [
  {
    name: 'Today',
    date: '',
    to: moment().format('YYYY-MM-DD'),
    from: moment().format('YYYY-MM-DD'),
    type: 'today',
  },
  {
    name: 'Yesterday',
    date: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    from: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    type: 'yesterday',
  },
  {
    name: 'Last week',
    date: '',
    from: moment()
      .subtract(1, 'weeks')
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'weeks')
      .weekday(7)
      .format('YYYY-MM-DD'),
    type: 'last_week',
  },
  {
    name: 'Last month',
    date: '',
    from: moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM-DD'),
    type: 'last_month',
  },
];

export default {
  components: { Loader, SalesDashboardCard },
  data() {
    return {
      loading: false,
      total_earned: 0,
      total_payout: 0,
      compared_earned: 0,
      compared_payout: 0,
      selectedFilter: filters[3],
      filters,
    };
  },
  watch: {
    selectedFilter() {
      this.getEarnings();
    },
  },
  mounted() {
    this.getEarnings();
  },
  methods: {
    getEarnings() {
      this.loading = true;
      axios
        .get(
          `/sales/earnings-sum?date=${this.selectedFilter.date}&date_from=${
            this.selectedFilter.from
          }&date_to=${this.selectedFilter.to}&type=${this.selectedFilter.type}`,
        )
        .then(res => {
          const { data } = res.data;
          this.total_earned = data.total_earned;
          this.total_payout = data.total_payout;
          this.compared_earned = data.compared_earned;
          this.compared_payout = data.compared_payout;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setFilter(filter) {
      this.selectedFilter = filter;
    },
  },
};
</script>

<style scoped>
.total-value {
  font-size: 20px;
  font-weight: 500;
}

.total-title {
  font-size: 12px;
  font-weight: 400;
  color: #bec0ca;
}

.compared-value {
  font-size: 10px;
  display: inline-block;
  margin-left: 5px;
}

.compared-value-positive {
  color: #00bfa5;
}

.compared-value-negative {
  color: #bf001a;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/Earnings.vue